(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3221);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5077:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/videog.48530d27.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAABAX/2gAMAwEAAhADEAAAALMSU//EABoQAQABBQAAAAAAAAAAAAAAAAERAAISIUL/2gAIAQEAAT8AuTJY5NTX/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQIDAP/aAAgBAgEBPwDeQ1oDv//EABYRAQEBAAAAAAAAAAAAAAAAAAECAP/aAAgBAwEBPwCFZN//2Q==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 3221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/layout/index.js + 5 modules
var layout = __webpack_require__(5962);
// EXTERNAL MODULE: ./src/styles/home.module.scss
var home_module = __webpack_require__(1941);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/home/landing/landing.module.scss
var landing_module = __webpack_require__(5852);
var landing_module_default = /*#__PURE__*/__webpack_require__.n(landing_module);
;// CONCATENATED MODULE: ./public/images/logo.png
/* harmony default export */ var logo = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/logo.aaf3eb56.png","height":170,"width":77,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAd0lEQVR42mMAgcML7QOAWJsBBg4vsK86tNB+BUxWGYiXAPF+sKrDi1wTDi9yewCkTxxe6NTPcGCOSvK+GQzH981k2HVwnkEDw9unN1Re3j/b8ebJteL///8LMACJEiCeCMRT//37V8oAJLL+/f07CYib/v37FwYAWK9Jiq9tTEoAAAAASUVORK5CYII=","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/home-section1.jpg
/* harmony default export */ var home_section1 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/home-section1.2dcb92b6.jpg","height":1068,"width":2103,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAQACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABQEBAAAAAAAAAAAAAAAAAAAAA//aAAwDAQACEAMQAAAAsAV//8QAHRABAAIBBQEAAAAAAAAAAAAAAgEDBAAFERIUIf/aAAgBAQABPwDL3fJo8KIqlqu5d0eUZMxHzX//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/bg-float1.png
/* harmony default export */ var bg_float1 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/bg-float1.7b858661.png","height":599,"width":476,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AQAAAAHPu2tsLiwf//T09tv///rn5+fu4QEAAAAKqJdS4lRQPBMDBAQA9/XwAPv7+HEBAAAAHGhYH9OOim8Q4uLl/Obl3wQcGxdeAQAAADGBcTXMZWFLAsrIwf/t69oB7O3xQgFCLgBJOjsdtlZVTf7r6ugC1tOv+wwONDABVEEAaB4eFJdVU0r9CQkJA+bm5ezn5ugrAXxnEXMDAfWLEBAU/SQlLwT7/QXm5fUQIQGLdRsJ/v3/FQsMDRfZ1Nkkr64AAeP/XaaGbllQ7N8j3AAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/bg-float2.png
/* harmony default export */ var bg_float2 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/bg-float2.b3135601.png","height":523,"width":432,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA80lEQVR4nAHoABf/Af///wBodX2YJywrGvv7/d8CAf7r/vz37vfw7roBAAAABkRMVN5CTE8bCQ0RAP359QD++O4AAAIBYwFJU1kUwa3B1XKQhRYMBwX85dLUAPkBAQQbFf9FASYlKyUDChLSUVxeCPn2+//b3OoBAQH6/vzcyzQBKzI+OQUJD8YyNzwAFhUO/9ba6gH89/LzAgH1LAEmLz1PBQcKsDE3O/waGhgA8O7xBPj07+Tj6+wrATdCUmwBAweTAgYOABocGQASDwkA/fnx3nJShiMBQEdWIQIIDjX9AAQTAwL/E+bo7iTb4OLkUVBPfDFLYJzBA+3aAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/bg-float3.png
/* harmony default export */ var bg_float3 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/bg-float3.867430d9.png","height":588,"width":462,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/Adl7TwHc8fg0AwQGHwIBAAz2+PfXNickyQG/dlJu/gABkQMDBAAFBAMA/vz74Qf15yYBt3BOc/4AAYz6+vz6/fz9BgEGA+z+AwEqAX47H1YD//+p+gIB/RUVEwPP6ez6ocbiMAGRVDRG/gECuej39/8VDwwA5OrvAf/8+kEBkVw6Mfv9/cr0+fkC/v3+/gsFBgQBAP9RAV06IB8E///gEAkHAA8KCAAFBAL3/wEBLgEAAAAHDwAAaB4PBwI1KRrgGhMM46/X5M0b31MBk84gRgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/bg-mask1.jpg
/* harmony default export */ var bg_mask1 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/bg-mask1.dc7ad71c.jpg","height":1034,"width":1455,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAYACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAA//aAAwDAQACEAMQAAAAnQ4f/8QAHhAAAAQHAAAAAAAAAAAAAAAAAAISEwQFFBUjUmL/2gAIAQEAAT8ALHS2wM0ORtKuth//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/gsap/dist/gsap.js
var gsap = __webpack_require__(458);
// EXTERNAL MODULE: ./src/components/home/landingBg/landingBg.module.scss
var landingBg_module = __webpack_require__(3157);
var landingBg_module_default = /*#__PURE__*/__webpack_require__.n(landingBg_module);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
;// CONCATENATED MODULE: ./src/components/home/landingBg/index.js





// Import Swiper Use

function LandingBg(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var screenWidth = window.innerWidth;
    // Animations
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // GSAP Split text
    (0,react.useEffect)(function() {
        var parallaxIt = function parallaxIt(e, target, movement) {
            var relX = e.pageX - container.offsetLeft;
            var relY = e.pageY - container.offsetTop;
            gsap.gsap.to(target, 1, {
                x: (relX - container.offsetWidth / 2) / container.offsetWidth * movement,
                y: (relY - container.offsetHeight / 2) / container.offsetHeight * movement
            });
        };
        if (swiperSlide.isActive) {
            gsap.gsap.set(".bg-image", {
                scale: 1.3,
                opacity: 0
            });
            gsap.gsap.set(".float1", {
                xPercent: -50,
                opacity: 0
            });
            gsap.gsap.set(".float2", {
                xPercent: -100,
                opacity: 0
            });
            gsap.gsap.set(".float3", {
                xPercent: 100,
                opacity: 0
            });
            //gsap.set('.bottom', {y: 100, opacity: 0});
            gsap.gsap.to(".bg-image", {
                scale: 1.1,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 1.8
            });
            gsap.gsap.to(".float1", {
                xPercent: 0,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 1.9
            });
            gsap.gsap.to(".float2", {
                xPercent: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 1.9
            });
            gsap.gsap.to(".float3", {
                xPercent: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 1.9
            });
        //gsap.to('.bottom', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.9 })
        }
        // Background Animation
        var container = document.querySelector(".body");
        container.addEventListener("mousemove", function(e) {
            parallaxIt(e, ".bg-image", -10);
            parallaxIt(e, ".bg-mask1", -50);
        });
    }, [
        swiperSlide.isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "section-bg absolute top-0 left-0 w-full h-full z-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-image scale-105 absolute top-0 left-0 w-full h-full z-auto ".concat((landingBg_module_default()).bgImage),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "object-cover object-center w-full h-full",
                        src: data === null || data === void 0 ? void 0 : (ref = data.bgImage) === null || ref === void 0 ? void 0 : ref.src,
                        height: data === null || data === void 0 ? void 0 : (ref1 = data.bgImage) === null || ref1 === void 0 ? void 0 : ref1.height,
                        width: data === null || data === void 0 ? void 0 : (ref2 = data.bgImage) === null || ref2 === void 0 ? void 0 : ref2.width,
                        blurDataURL: data === null || data === void 0 ? void 0 : (ref3 = data.bgImage) === null || ref3 === void 0 ? void 0 : ref3.blurDataURL,
                        placeholder: "blur",
                        priority: true,
                        alt: "Section BG"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "float1 absolute ".concat(screenWidth < 767 ? "right-0" : "left-0", " top-0 w-auto z-30 ").concat((landingBg_module_default()).float1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "block",
                        src: data === null || data === void 0 ? void 0 : (ref4 = data.float1) === null || ref4 === void 0 ? void 0 : ref4.src,
                        height: data === null || data === void 0 ? void 0 : (ref5 = data.float1) === null || ref5 === void 0 ? void 0 : ref5.height,
                        width: data === null || data === void 0 ? void 0 : (ref6 = data.float1) === null || ref6 === void 0 ? void 0 : ref6.width,
                        blurDataURL: data === null || data === void 0 ? void 0 : (ref7 = data.float1) === null || ref7 === void 0 ? void 0 : ref7.blurDataURL,
                        placeholder: "blur",
                        alt: "Image"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "float2 absolute left-0 bottom-0 w-auto z-30 ".concat((landingBg_module_default()).float2),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "block",
                        src: data === null || data === void 0 ? void 0 : (ref8 = data.float2) === null || ref8 === void 0 ? void 0 : ref8.src,
                        height: data === null || data === void 0 ? void 0 : (ref9 = data.float2) === null || ref9 === void 0 ? void 0 : ref9.height,
                        width: data === null || data === void 0 ? void 0 : (ref10 = data.float2) === null || ref10 === void 0 ? void 0 : ref10.width,
                        blurDataURL: data === null || data === void 0 ? void 0 : (ref11 = data.float2) === null || ref11 === void 0 ? void 0 : ref11.blurDataURL,
                        placeholder: "blur",
                        alt: "Image"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "float3 absolute right-0 ".concat(screenWidth < 767 ? "bottom-0" : "top-0", " w-auto z-30 ").concat((landingBg_module_default()).float3),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "block",
                        src: data.float3.src,
                        height: data.float3.height,
                        width: data.float3.width,
                        blurDataURL: data.float3.blurDataURL,
                        placeholder: "blur",
                        alt: "Image"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-mask1 absolute top-0 left-0 w-full h-full z-40 opacity-50 mix-blend-multiply bg-center bg-no-repeat bg-cover scale-110 ".concat((landingBg_module_default()).bgMask),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "block object-cover w-full h-full object-center",
                        src: data.bgMask.src,
                        height: data.bgMask.height,
                        width: data.bgMask.width,
                        blurDataURL: data.bgMask.blurDataURL,
                        placeholder: "blur",
                        alt: "Mask"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-mask2 absolute top-0 left-0 w-full h-full z-50 opacity-70 mix-blend-multiply",
                    style: {
                        backgroundColor: "#223A57"
                    }
                })
            ]
        })
    });
}
/* harmony default export */ var landingBg = (LandingBg);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var node_modules_gsap = __webpack_require__(326);
;// CONCATENATED MODULE: ./src/components/split-text/index.js





// Import Swiper Use


function TextSplit(_param) {
    var data = _param.data, tag = _param.tag, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "tag"
    ]);
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // Split Text
    var chars = data.split("");
    // GSAP Split text
    (0,react.useEffect)(function() {
        node_modules_gsap/* gsap.set */.p8.set(".text-1, .text-2, .text-3", {
            y: 100,
            opacity: 0
        });
        node_modules_gsap/* gsap.to */.p8.to(".text-1", {
            y: 0,
            opacity: 1,
            ease: "ease.in",
            duration: 1
        });
        node_modules_gsap/* gsap.to */.p8.to(".text-2", {
            y: 0,
            opacity: 1,
            ease: "ease.out",
            duration: 1,
            delay: 0.2
        });
        node_modules_gsap/* gsap.to */.p8.to(".text-3", {
            y: 0,
            opacity: 1,
            ease: "ease.inOut",
            duration: 1,
            delay: 0.4
        });
    }, [
        swiperSlide.isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tag == "h1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-1 relative inline-block",
                    children: chars[0]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-2 relative inline-block",
                    children: chars[1]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-3 relative inline-block",
                    children: chars[2]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-1 relative inline-block",
                    children: chars[3]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-2 relative inline-block",
                    children: chars[4]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-3 relative inline-block",
                    children: chars[5]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-1 relative inline-block",
                    children: chars[6]
                })
            ]
        }))
    });
}
/* harmony default export */ var split_text = (TextSplit);

// EXTERNAL MODULE: ./src/components/actions/default-click.js
var default_click = __webpack_require__(7869);
// EXTERNAL MODULE: ./src/components/actions/default-hover.js
var default_hover = __webpack_require__(9148);
// EXTERNAL MODULE: ./src/components/icons/arrow.js
var arrow = __webpack_require__(6267);
;// CONCATENATED MODULE: ./public/images/mobile/bg-mask.jpg
/* harmony default export */ var bg_mask = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/bg-mask.79cc3c1a.jpg","height":674,"width":479,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABgMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAAKEUH//EABsQAAIBBQAAAAAAAAAAAAAAAAMSAAEEERRB/9oACAEBAAE/AD1sNYCK3cT/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/mobile/landing-bg.jpg
/* harmony default export */ var landing_bg = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/landing-bg.e848f2f8.jpg","height":640,"width":360,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABQMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABQEBAAAAAAAAAAAAAAAAAAAAA//aAAwDAQACEAMQAAAAsAk//8QAHBABAAEEAwAAAAAAAAAAAAAAAQMAAgQhBhIT/9oACAEBAAE/ALcnjl/WX3yJL2MFZGPQqar/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/home/landing/index.js












// Import Swiper Use


// Page Musics



// Mobile Assets


function Landing(isActive) {
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    var screenWidth = window.innerWidth;
    var pageMask = screenWidth < 767 ? bg_mask : bg_mask1;
    var pageImage = screenWidth < 767 ? landing_bg : home_section1;
    var pageData = {
        bgData: {
            bgImage: pageImage,
            float1: bg_float1,
            float2: bg_float2,
            float3: bg_float3,
            bgMask: pageMask
        },
        title: "במסתרים",
        subtitle: "סיפורם של ילדי מסתור בתקופת השואה"
    };
    // Swiper 
    var swiper = (0,swiper_react/* useSwiper */.oc)();
    //console.log(swiperSlide.isActive);
    // GSAP Split text
    (0,react.useEffect)(function() {
        //gsap.set('.logo', {y: 100, opacity: 0}); 
        gsap.gsap.set(".title", {
            y: 100,
            opacity: 0
        });
        gsap.gsap.set(".subtitle", {
            y: 100,
            opacity: 0
        });
        gsap.gsap.set(".next-section", {
            y: 100,
            opacity: 0
        });
        if (document.querySelector(".mobileToaster")) {
            gsap.gsap.set(".mobileToaster", {
                y: 100,
                opacity: 0
            });
        }
        //const tl = gsap.timeline(); 
        //gsap.to('.logo', {y:0, opacity: 1, ease:"ease.in", duration: 1, delay: 2})
        gsap.gsap.to(".title", {
            y: 0,
            opacity: 1,
            ease: "ease.out",
            duration: 1,
            delay: 2.2
        });
        gsap.gsap.to(".subtitle", {
            y: 0,
            opacity: 1,
            ease: "ease.inOut",
            duration: 1,
            delay: 2.4
        });
        gsap.gsap.to(".next-section", {
            y: 0,
            opacity: 1,
            ease: "ease.inOut",
            duration: 1,
            delay: 2.6
        });
        if (document.querySelector(".mobileToaster")) {
            gsap.gsap.to(".mobileToaster", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 2.7
            });
        }
    //tl.restart();
    }, [
        swiperSlide.isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingBg, {
                data: pageData.bgData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "landing",
                className: "landing-wrapper m-auto relative z-20 text-center ".concat((landing_module_default()).landing),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: logo.width,
                        height: logo.height,
                        className: "logo inline-block ".concat((landing_module_default()).logo),
                        src: logo.src,
                        alt: "םירתסמב"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(split_text, {
                        tag: "h1",
                        className: "title title-font text-white ".concat((landing_module_default()).title),
                        data: pageData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "subtitle title-font text-5xl ".concat((landing_module_default()).subtitle),
                        children: pageData.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "next-section relative text-white inline-block ".concat((landing_module_default()).magnetic),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                swiper.slideNext();
                                (0,default_click/* default */.Z)();
                            },
                            onMouseEnter: function() {
                                (0,default_hover/* default */.Z)();
                            },
                            className: "ml-auto mr-auto flex justify-center items-center ".concat((landing_module_default()).button),
                            children: [
                                screenWidth < 767 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (landing_module_default()).text,
                                    children: "להתנסות"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex items-center justify-center bg-white w-12 h-12 md:w-10 md:h-10 text-center rounded-full ".concat((landing_module_default()).icon),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {})
                                })
                            ]
                        })
                    }),
                    screenWidth < 767 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobileToaster ".concat((landing_module_default()).mobileToaster),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((landing_module_default()).toasterContent),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "התערוכה המלאה לא זמינה בטלפון נייד,",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "עברו למסך מחשב והתחילו לגלות"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    if (navigator.share) {
                                        navigator.share({
                                            title: "'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.",
                                            text: "גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור.",
                                            url: "https://bamistarim.ganzach.org.il/"
                                        }).then(function() {
                                            return console.log("Successful share");
                                        }).catch(function(error) {
                                            return console.log("Error sharing", error);
                                        });
                                    } else {
                                        console.log("Share not supported on this browser, do it the old way.");
                                    }
                                },
                                className: (landing_module_default()).toasterButton,
                                children: "שלחו לי קישור למייל או לוואטסאפ"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var landing = (Landing);

// EXTERNAL MODULE: ./src/components/home/section1/section1.module.scss
var section1_module = __webpack_require__(3203);
var section1_module_default = /*#__PURE__*/__webpack_require__.n(section1_module);
;// CONCATENATED MODULE: ./public/images/home-section2.jpg
/* harmony default export */ var home_section2 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/home-section2.21388f28.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAABAX/2gAMAwEAAhADEAAAAKEIq//EABgQAAIDAAAAAAAAAAAAAAAAAAIRACFR/9oACAEBAAE/AGzPKU//xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIDIf/aAAgBAgEBPwDcK62A5P/EABYRAQEBAAAAAAAAAAAAAAAAAAECAP/aAAgBAwEBPwCFZN//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/mobile/section2.jpg
/* harmony default export */ var section2 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/section2.0dbab6bb.jpg","height":738,"width":437,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABQMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAABAX/2gAMAwEAAhADEAAAAKGITf/EABgQAAIDAAAAAAAAAAAAAAAAAAABAjJR/9oACAEBAAE/AHaSxn//xAAXEQEBAQEAAAAAAAAAAAAAAAACAQAD/9oACAECAQE/AOhhak3/xAAXEQEAAwAAAAAAAAAAAAAAAAABAAIh/9oACAEDAQE/AK6E/9k=","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/button-bg.png
/* harmony default export */ var button_bg = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/button-bg.e6dade4c.png","height":50,"width":50,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEXo5d3l4trm49zm49vm4tvn5Nzm49vk4dnn5Nzm49zm4tvo5d7n5N3n49zl4trn5N3m49zm49vl4trn5N3m4tvl4tvo5d7n5N3n5Nzm49zl4trk4dno5d7o5d3o5N3n5N3n5Nzn49zm49zm49vl4trl4tnl4dnk4dnj4Nfw1Vl1AAAAHHRSTlMAACkpKSoqKsDAwMHBwcHu7u7u+fn5+vr6+vr6oAOz6AAAAEdJREFUeNoFQAUSgCAQXBPswETwKMX/v9ABil5eVQ6kk/OPm0vUblG0mganD9HqKCFD/F6yBzoj6BbEwUanFQ0pkoxve8uSH8kjBX/JrgYwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/components/home/sectionBg/sectionBg.module.scss
var sectionBg_module = __webpack_require__(9428);
var sectionBg_module_default = /*#__PURE__*/__webpack_require__.n(sectionBg_module);
;// CONCATENATED MODULE: ./src/components/home/sectionBg/index.js





// Import Swiper Use

function SectionBg(param) {
    var data = param.data, moveBG = param.moveBG, classes = param.classes;
    var ref, ref1, ref2, ref3;
    //console.log(data);
    // Animations
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // GSAP Split text
    (0,react.useEffect)(function() {
        node_modules_gsap/* gsap.set */.p8.set(".section-bg", {
            scale: 1.2,
            opacity: 0
        });
        node_modules_gsap/* gsap.to */.p8.to(".section-bg", {
            scale: 1,
            opacity: 1,
            ease: "power.out",
            duration: 1,
            delay: 0
        });
    }, [
        swiperSlide.isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "section-bg ".concat((sectionBg_module_default()).sectionBG, " absolute left-0 top-0 w-full h-full z-10 ").concat(classes),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "object-cover object-center w-full h-full",
                src: data === null || data === void 0 ? void 0 : (ref = data.bgImage) === null || ref === void 0 ? void 0 : ref.src,
                height: data === null || data === void 0 ? void 0 : (ref1 = data.bgImage) === null || ref1 === void 0 ? void 0 : ref1.height,
                width: data === null || data === void 0 ? void 0 : (ref2 = data.bgImage) === null || ref2 === void 0 ? void 0 : ref2.width,
                blurDataURL: data === null || data === void 0 ? void 0 : (ref3 = data.bgImage) === null || ref3 === void 0 ? void 0 : ref3.blurDataURL,
                placeholder: "blur",
                alt: "Section BG"
            })
        })
    });
}
/* harmony default export */ var sectionBg = (SectionBg);

;// CONCATENATED MODULE: ./src/components/home/section1/index.js








// Import Swiper Use




function Section1() {
    var screenWidth = window.innerWidth;
    var pageBG = screenWidth < 767 ? section2 : home_section2;
    var bgData = {
        bgImage: pageBG
    };
    var pageData = {
        title: "נעים מאד,",
        content: "אנחנו רות ושרה.<br/>יש לנו סיפור מיוחד שאנחנו מתרגשות לספר. הוא מתחיל על האניה בדרך לארץ ישראל..."
    };
    // Swiper 
    var swiper = (0,swiper_react/* useSwiper */.oc)();
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // GSAP Split text
    (0,react.useEffect)(function() {
        //console.log(swiperSlide);
        if (swiperSlide.isActive) {
            if (screenWidth > 767) {
                gsap.gsap.set("#header", {
                    xPercent: 100,
                    opacity: 0
                });
                gsap.gsap.to("#header", {
                    xPercent: 0,
                    opacity: 1,
                    ease: "ease.in",
                    duration: 1
                });
            }
            gsap.gsap.set(".ptitle", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.set(".content", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.set(".button", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.to(".ptitle", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0
            });
            gsap.gsap.to(".content", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.2
            });
            gsap.gsap.to(".button", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.4
            });
        }
    }, [
        swiperSlide.isActive,
        screenWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionBg, {
                data: bgData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "section-wrapper relative z-20 ".concat((section1_module_default()).wrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "ptitle ".concat((section1_module_default()).title),
                        children: pageData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "content ".concat((section1_module_default()).content),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: pageData.content
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button ".concat((section1_module_default()).magnetic),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                swiper.slideNext();
                                (0,default_click/* default */.Z)();
                            },
                            onMouseEnter: function() {
                                (0,default_hover/* default */.Z)();
                            },
                            className: "".concat((section1_module_default()).button),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (section1_module_default()).text,
                                    children: "לסיפור שלנו"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex items-center justify-center ".concat((section1_module_default()).icon),
                                    style: {
                                        backgroundImage: "url(".concat(button_bg.src, ")")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var section1 = (Section1);

;// CONCATENATED MODULE: ./public/images/home-section3.jpg
/* harmony default export */ var home_section3 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/home-section3.326a45d4.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAABAX/2gAMAwEAAhADEAAAAKQIrP/EABkQAQACAwAAAAAAAAAAAAAAAAEAAgMRQf/aAAgBAQABPwDLUqmuk//EABgRAAMBAQAAAAAAAAAAAAAAAAECAwAh/9oACAECAQE/ALqFq4A5v//EABcRAAMBAAAAAAAAAAAAAAAAAAABAiH/2gAIAQMBAT8AjZR//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/mobile/section3.jpg
/* harmony default export */ var section3 = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/section3.7e4159d8.jpg","height":781,"width":371,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgABAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAABAX/2gAMAwEAAhADEAAAAKIILf/EABcQAQADAAAAAAAAAAAAAAAAAAEAAhH/2gAIAQEAAT8ARq4z/8QAGBEBAQADAAAAAAAAAAAAAAAAAQIAEkH/2gAIAQIBAT8As1ug45//xAAWEQEBAQAAAAAAAAAAAAAAAAABACH/2gAIAQMBAT8ANC//2Q==","blurWidth":4,"blurHeight":8});
// EXTERNAL MODULE: ./public/images/videog.jpg
var videog = __webpack_require__(5077);
// EXTERNAL MODULE: ./src/components/home/section2/section2.module.scss
var section2_module = __webpack_require__(6847);
var section2_module_default = /*#__PURE__*/__webpack_require__.n(section2_module);
;// CONCATENATED MODULE: ./public/images/play-small.svg
/* harmony default export */ var play_small = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/play-small.e9d47c1f.svg","height":27,"width":17});
// EXTERNAL MODULE: ./src/components/magicButton/index.js
var magicButton = __webpack_require__(4102);
// EXTERNAL MODULE: ./src/components/actions/video-hover.js
var video_hover = __webpack_require__(3938);
;// CONCATENATED MODULE: ./src/components/home/section2/index.js










// Import Swiper Use







function Section2(param) {
    var music = param.music;
    var isMusicPlaying = function isMusicPlaying(audelem) {
        return !(audelem === null || audelem === void 0 ? void 0 : audelem.paused);
    };
    var screenWidth = window.innerWidth;
    var pageBG = screenWidth < 767 ? section3 : home_section3;
    var bgData = {
        bgImage: pageBG
    };
    var videoData = {
        video: "https://bamistarim.ganzach.org.il/assets" + "/video/hiding-video.mp4",
        poster: videog/* default */.Z,
        buttonText: "להמשיך לתערוכה"
    };
    // Use State
    var ref = (0,react.useState)(false), playVideo = ref[0], setPlayvideo = ref[1];
    var video = (0,react.useRef)(null);
    //const videoPlay = useRef(null);
    var playVideoClick = function(data) {
        if (data) {
            setPlayvideo(true);
        } else {
            setPlayvideo(false);
        }
    };
    if (video.current) {
        video.current.onplay = function() {
            setPlayvideo(true);
        };
        video.current.onpause = function() {
            setPlayvideo(false);
        };
    }
    // On Video Play/Pause
    (0,react.useEffect)(function() {
        // get the background player
        var backAudio = localStorage.getItem("backgroundMusic");
        //console.log(playVideo);
        if (playVideo) {
            // Background Music
            if (isMusicPlaying(music) && backAudio === "playing") {
                video.current.play();
                gsap.gsap.to(video.current, {
                    volume: 1,
                    duration: 2
                });
                // BG Music
                gsap.gsap.to(music, {
                    volume: 0,
                    duration: 1.5,
                    onComplete: function() {
                        music.pause();
                    }
                });
            } else {
                video.current.play();
                video.current.volume = 1;
            }
        } else {
            // Background Music
            if (!isMusicPlaying(music) && backAudio === "playing") {
                gsap.gsap.to(video.current, {
                    volume: 0,
                    duration: 1.5,
                    onComplete: function() {
                        video.current.pause();
                    }
                });
                // BG Music
                music.play();
                gsap.gsap.to(music, {
                    volume: 1,
                    duration: 2
                });
            } else {
                video.current.pause();
            }
        }
    }, [
        playVideo,
        music
    ]);
    // Swiper 
    var swiper = (0,swiper_react/* useSwiper */.oc)();
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // GSAP Split text
    (0,react.useEffect)(function() {
        gsap.gsap.set(".section-video", {
            scale: 1.5,
            opacity: 0
        });
        gsap.gsap.set(".button", {
            y: 100,
            opacity: 0
        });
        gsap.gsap.set(".closeBtn", {
            y: -100,
            opacity: 0
        });
        if (swiperSlide.isActive) {
            gsap.gsap.to(".section-video", {
                scale: 1,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0
            });
            gsap.gsap.to(".button", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.4
            });
            gsap.gsap.to(".closeBtn", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.6
            });
        }
        // On End Video
        if (video.current) {
            video.current.addEventListener("ended", function() {
                swiper.slideNext();
            }, false);
        }
    }, [
        swiperSlide.isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            screenWidth < 767 && /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionBg, {
                data: bgData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "section-wrapper flex flex-wrap relative z-20 ".concat((section2_module_default()).wrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section-video w-full h-full relative ".concat((section2_module_default()).video, " ").concat(playVideo && "playing"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    (0,default_click/* default */.Z)();
                                    playVideoClick(false);
                                    swiper.slidePrev();
                                },
                                onMouseEnter: function() {
                                    (0,default_hover/* default */.Z)();
                                },
                                className: "absolute closeBtn z-50 ".concat((section2_module_default()).closeButton),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "26",
                                    height: "26",
                                    viewBox: "0 0 26 26",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M25.8334 2.75297L23.2484 0.167969L13.0001 10.4163L2.75175 0.167969L0.166748 2.75297L10.4151 13.0013L0.166748 23.2496L2.75175 25.8346L13.0001 15.5863L23.2484 25.8346L25.8334 23.2496L15.5851 13.0013L25.8334 2.75297Z",
                                        fill: "white"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                ref: video,
                                poster: videoData.poster.src,
                                controls: true,
                                controlsList: "nodownload ".concat(screenWidth > 767 && "nofullscreen"),
                                className: "w-full h-full overflow-hidden z-10 relative object-cover",
                                preload: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: videoData.video,
                                    type: "video/mp4"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-40 absolute top-0 right-0 w-full overflow-hidden ".concat((section2_module_default()).videoOverlay, " ").concat(playVideo && "hidden"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        playVideoClick(!playVideo);
                                        (0,default_click/* default */.Z)();
                                    },
                                    onMouseEnter: function() {
                                        return (0,video_hover/* default */.Z)();
                                    },
                                    className: "play-btn fixed left-1/2 top-1/2 z-20 rounded-full transition-colors ".concat((section2_module_default()).playButton),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: play_small,
                                        alt: "Play"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(magicButton/* default */.Z, {
                        className: "absolute button inline-block mr-auto p-10 z-50 ".concat((section2_module_default()).magnetic),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                swiper.slideNext();
                                (0,default_click/* default */.Z)();
                                setPlayvideo(false);
                            },
                            onMouseEnter: function() {
                                (0,default_hover/* default */.Z)();
                            },
                            className: "".concat((section2_module_default()).button),
                            children: videoData.buttonText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button flex justify-center w-full ".concat((section2_module_default()).nextPage),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                swiper.slideNext();
                                (0,default_click/* default */.Z)();
                            },
                            onMouseEnter: function() {
                                (0,default_hover/* default */.Z)();
                            },
                            className: "flex items-center ".concat((section2_module_default()).button),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (section2_module_default()).text,
                                    children: "רוצים לפגוש עוד סיפורים?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex items-center justify-center ".concat((section2_module_default()).icon),
                                    style: {
                                        backgroundImage: "url(".concat(button_bg.src, ")")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_home_section2 = (Section2);

// EXTERNAL MODULE: ./src/components/home/section3/section3.module.scss
var section3_module = __webpack_require__(6615);
var section3_module_default = /*#__PURE__*/__webpack_require__.n(section3_module);
;// CONCATENATED MODULE: ./public/images/toasters/toaster.png
/* harmony default export */ var toaster = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/toaster.a1e8b1da.png","height":178,"width":178,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABB0lEQVR42mMAgUvbOxUubevYvm560fdVU4p+nNvUsvPazg4FBhA4uqpB8sKWtjuzO7L+K5q5/GdgUPrfW5f6//zmtrun1jdLMlza1jn3wNLy/xMmTf55/drl/yER0UBFXL9WTS3+f31X1xyGc5varp5aW/tv3461f64BFWzbtuV/QHTGvxWTi/5f2d5xleHspvazp9dW/b9+bv/vDx/e/L9799b/5NT0v2c2NP8/u7H1LMOJdW1l5zY2/j+8YdL3cxfO/tmxbesfdXnt31vnlf+/uKW9nAEEzm1pX7ZhYs7/aXk5//dMaP8/Lyfpf0Js0AoGZLCpoyx1R0vV5g3V+Zt3t5SnwcQB5XuSA6mER7wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/icons/quote.js
var quote = __webpack_require__(5701);
// EXTERNAL MODULE: ./src/components/icons/question.js
var question = __webpack_require__(7350);
// EXTERNAL MODULE: ./src/components/actions/toasterSound.js
var toasterSound = __webpack_require__(4546);
;// CONCATENATED MODULE: ./src/components/home/section3/index.js











// Import Swiper Use







function Section3() {
    var screenWidth = window.innerWidth;
    var pageBG = screenWidth < 767 ? section3 : home_section3;
    var bgData = {
        bgImage: pageBG
    };
    var pageData = {
        title: "אנחנו לא היינו הילדים היחידים שהתחבאו.",
        content: "אלו היו הסיפורים שלנו, שרה ורות,  כמונו היו אלפי ילדים, תינוקות, נערים ונערות מכל מיני מקומות. לכל אחד מהם היה סיפור משלו."
    };
    // Animations
    var swiperSlide = (0,swiper_react/* useSwiperSlide */.c6)();
    // GSAP Split text
    (0,react.useEffect)(function() {
        if (document.querySelector(".toasterBox")) {
            gsap.gsap.set(".toasterBox", {
                scale: 0,
                opacity: 0
            });
        }
        if (swiperSlide.isActive) {
            gsap.gsap.set(".title", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.set(".content", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.set(".button", {
                y: 100,
                opacity: 0
            });
            gsap.gsap.set(".bottom", {
                y: 100,
                opacity: 0
            });
            if (document.querySelector(".mobileToaster")) {
                gsap.gsap.set(".mobileToaster", {
                    y: 100,
                    opacity: 0
                });
            }
            gsap.gsap.to(".title", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0
            });
            gsap.gsap.to(".content", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.3
            });
            gsap.gsap.to(".button", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.6
            });
            gsap.gsap.to(".bottom", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 0.9
            });
            gsap.gsap.to(".mobileToaster", {
                y: 0,
                opacity: 1,
                ease: "ease.inOut",
                duration: 1,
                delay: 1
            });
            // Popup Toaster
            setTimeout(function() {
                gsap.gsap.to(".toasterBox", {
                    scale: 1,
                    opacity: 1,
                    ease: "ease.inOut",
                    duration: 0.5,
                    delay: 0
                });
                (0,toasterSound/* default */.Z)();
            }, 1000);
        }
    }, [
        swiperSlide.isActive
    ]);
    // Redirect page
    /* const redirectPage = () => {
    setTimeout(function() {
      window.location.replace("/story");
    }, 500);
    //window.location.replace("/front-end/story");
  } */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionBg, {
                data: bgData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "section-wrapper z-20 ".concat((section3_module_default()).wrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section-top",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "title ".concat((section3_module_default()).title),
                                children: pageData.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "content ".concat((section3_module_default()).content),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: pageData.content
                                })
                            })
                        ]
                    }),
                    screenWidth > 767 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bottom relative flex items-center ".concat((section3_module_default()).infoBox),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((section3_module_default()).toasterImage),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: toaster.width,
                                    height: toaster.height,
                                    blurDataURL: toaster === null || toaster === void 0 ? void 0 : toaster.blurDataURL,
                                    placeholder: "blur",
                                    className: "inline-block",
                                    src: toaster.src,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "toasterBox ".concat((section3_module_default()).toasterContent, " absolute bottom-0 right-full mr-5"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((section3_module_default()).right, " mb-5"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (section3_module_default()).subtitle,
                                                children: "שימו לב!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "במהלך הסיור חפשו פרטים נוספים על ילדי המסתור:"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((section3_module_default()).left),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (section3_module_default()).infoWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-start rounded mb-2.5 w-full transition-colors ".concat((section3_module_default()).infoButton),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "flex items-center justify-center ".concat((section3_module_default()).infoIcon),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quote/* default */.Z, {
                                                                color: "#223A57"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (section3_module_default()).infoText,
                                                            children: "עדויות של ניצולים"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (section3_module_default()).infoWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-start rounded w-full transition-colors ".concat((section3_module_default()).infoButton),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "flex items-center justify-center ".concat((section3_module_default()).infoIcon),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(question/* default */.Z, {
                                                                color: "#223A57"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (section3_module_default()).infoText,
                                                            children: "שאלות לסקרנים"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    screenWidth > 767 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button absolute ".concat((section3_module_default()).button),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative flex ".concat((section3_module_default()).magneticLink),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/story/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    onClick: function() {
                                        (0,default_click/* default */.Z)();
                                    },
                                    onMouseEnter: function() {
                                        (0,default_hover/* default */.Z)();
                                    },
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text",
                                            children: "רוצים  לפגוש עוד סיפורים?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "flex items-center justify-center ".concat((section3_module_default()).icon),
                                            style: {
                                                backgroundImage: "url(".concat(button_bg.src, ")")
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {})
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    screenWidth < 767 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobileToaster ".concat((section3_module_default()).mobileToaster),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center ".concat((section3_module_default()).toasterContent),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "את הסיפורים, העדויות ותשובות לשאלות תמצאו בתערוכה המלאה."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "עברו למסך מחשב והתחילו לגלות!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    if (navigator.share) {
                                        navigator.share({
                                            title: "'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.",
                                            text: "גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור.",
                                            url: "https://bamistarim.ganzach.org.il/"
                                        }).then(function() {
                                            return console.log("Successful share");
                                        }).catch(function(error) {
                                            return console.log("Error sharing", error);
                                        });
                                    } else {
                                        console.log("Share not supported on this browser, do it the old way.");
                                    }
                                },
                                className: (section3_module_default()).toasterButton,
                                children: "שלחו לי קישור למייל או לוואטסאפ"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_home_section3 = (Section3);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(9846);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
;// CONCATENATED MODULE: ./pages/index.js








// Import Swiper React components

// Import Swiper styles



// import required modules

function Index(param) {
    var dataAudio = param.dataAudio, dataAudio2 = param.dataAudio2;
    var swiper = (0,swiper_react/* useSwiper */.oc)();
    var screenWidth = window.innerWidth;
    //console.log(dataAudio2);
    var vcontainer = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        header: screenWidth < 767 ? "hide" : "show",
        setHide: "true",
        footer: "hide",
        mainDir: "ltr",
        audio: dataAudio,
        audio2: dataAudio2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            spaceBetween: 0,
            slidesPerView: 1,
            effect: "fade",
            navigation: false,
            pagination: false,
            mousewheel: false,
            keyboard: false,
            allowTouchMove: false,
            modules: [
                swiper_esm/* EffectFade */.xW,
                swiper_esm/* Navigation */.W_,
                swiper_esm/* Pagination */.tl,
                swiper_esm/* Mousewheel */.Gk,
                swiper_esm/* Keyboard */.N1
            ],
            ref: vcontainer,
            className: "vertical-wrapper ".concat((home_module_default()).container),
            id: "vertical-scroll",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: "v-section relative h-screen w-screen flex content-center overflow-hidden justify-center ".concat((home_module_default()).color1, " ").concat((home_module_default()).section),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(landing, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: "v-section relative h-screen w-screen flex content-center overflow-hidden justify-center ".concat((home_module_default()).color2, " ").concat((home_module_default()).section),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section1, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: "v-section relative h-screen w-screen flex content-center overflow-hidden justify-center ".concat((home_module_default()).color2, " ").concat((home_module_default()).section),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_home_section2, {
                        music: dataAudio
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: "v-section relative h-screen w-screen flex content-center overflow-hidden justify-center ".concat((home_module_default()).color2, " ").concat((home_module_default()).section),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_home_section3, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 3938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _public_sounds_HoverTick_mp3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6671);
/* harmony import */ var _public_sounds_HoverTick_mp3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_public_sounds_HoverTick_mp3__WEBPACK_IMPORTED_MODULE_0__);

var videoHover = function() {
    var player = new Audio((_public_sounds_HoverTick_mp3__WEBPACK_IMPORTED_MODULE_0___default()));
    player.play();
};
/* harmony default export */ __webpack_exports__["Z"] = (videoHover);


/***/ }),

/***/ 4102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(326);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8421);







var Magnetic = function(_param) {
    var children = _param.children, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    //gsap.registerPlugin(TweenMax);
    var button = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var strength = 50;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (button && button.current) {
            var moveMagnet = function moveMagnet(event) {
                var magnetButton = event.currentTarget;
                var bounding = magnetButton.getBoundingClientRect();
                //console.log(magnetButton, bounding)
                gsap__WEBPACK_IMPORTED_MODULE_3__/* .gsap.to */ .p8.to(magnetButton, 1, {
                    x: ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) * strength,
                    y: ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) * strength,
                    ease: gsap__WEBPACK_IMPORTED_MODULE_4__/* .Power4.easeOut */ .Yp.easeOut
                });
            };
            button.current.addEventListener("mousemove", moveMagnet);
            button.current.addEventListener("mouseout", function(event) {
                gsap__WEBPACK_IMPORTED_MODULE_3__/* .gsap.to */ .p8.to(event.currentTarget, 1, {
                    x: 0,
                    y: 0,
                    ease: gsap__WEBPACK_IMPORTED_MODULE_4__/* .Power4.easeOut */ .Yp.easeOut
                });
            });
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: button
    }, params), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Magnetic);


/***/ }),

/***/ 5852:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__sh_S_","logo":"landing_logo__VuTNt","title":"landing_title__0M5HT","subtitle":"landing_subtitle__2ykzl","magnetic":"landing_magnetic__ynq7I","button":"landing_button__DfiDy","icon":"landing_icon__8P1XM","mobileToaster":"landing_mobileToaster__zUtGT","iconImage":"landing_iconImage__71bqT","text":"landing_text__YKpfw","toasterContent":"landing_toasterContent__8xRef","toasterButton":"landing_toasterButton__5Auuf"};

/***/ }),

/***/ 3157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"landingBg_bgImage__Es6jd","float1":"landingBg_float1__90SMC","float2":"landingBg_float2__l9Xyi","float3":"landingBg_float3__57Ha8","bgMask":"landingBg_bgMask__8UOKb"};

/***/ }),

/***/ 3203:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section1_wrapper__JOuAq","magnetic":"section1_magnetic__o_rn8","button":"section1_button__eoBwK","icon":"section1_icon__nTW8Z","title":"section1_title__Dw9Nn","content":"section1_content__nNZBS","image":"section1_image__j_I3p","text":"section1_text__5KV91"};

/***/ }),

/***/ 6847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section2_wrapper__1urI8","video":"section2_video__kE30u","closeButton":"section2_closeButton__yPzn6","videoPlayer":"section2_videoPlayer__jiaF_","videoOverlay":"section2_videoOverlay___bWzO","playButton":"section2_playButton__9VGQ2","caption":"section2_caption__7WHoZ","captionWrapper":"section2_captionWrapper__yxYRt","magnetic":"section2_magnetic__b6j5o","button":"section2_button__da7DT","icon":"section2_icon__11qa7","image":"section2_image__j5U7L","nextPage":"section2_nextPage___1z72","text":"section2_text__7TDF3"};

/***/ }),

/***/ 6615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section3_wrapper__Tcx7q","button":"section3_button__QdjAE","link":"section3_link__nNIhP","icon":"section3_icon__FTelI","title":"section3_title__ZE7OX","content":"section3_content__NuGxA","infoBox":"section3_infoBox___GEyI","toasterImage":"section3_toasterImage__ILFP2","toasterContent":"section3_toasterContent__lwuya","left":"section3_left__vFNUs","infoButton":"section3_infoButton__AYqwG","infoIcon":"section3_infoIcon__CPgZ1","right":"section3_right__xzGo4","subtitle":"section3_subtitle__r9C02","image":"section3_image__L_x8d","infoImage":"section3_infoImage__qvGHc","mobileToaster":"section3_mobileToaster__kKKLr","toasterButton":"section3_toasterButton__zrzF0"};

/***/ }),

/***/ 9428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionBG":"sectionBg_sectionBG__jw_zc"};

/***/ }),

/***/ 1941:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__vghhx","section":"home_section__ZSNWZ","color1":"home_color1__Ffh6h","color2":"home_color2__ztcOK"};

/***/ }),

/***/ 6671:
/***/ (function(module) {

module.exports = "data:audio/mpeg;base64,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"

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [802,362,282,3,962,680,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);